// extracted by mini-css-extract-plugin
module.exports = {"wallet":"Wallet_wallet__13Df-","walletSelect":"Wallet_walletSelect__9FV4m"};